import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showSummary
        ? _c(
            "fieldset",
            { staticClass: "fieldset pa-3 mb-3" },
            [
              _c("legend", { staticClass: "px-2 summary-legend" }, [
                _vm._v(_vm._s("Resumen de la ejecución")),
              ]),
              _c(
                "div",
                {
                  staticClass: "metric-row d-flex flex-nowrap",
                  staticStyle: { gap: "28px" },
                },
                [
                  _vm.rowCount !== null
                    ? _c(
                        "div",
                        {
                          staticClass: "metric-item",
                          staticStyle: { flex: "1 1 0", "min-width": "0" },
                        },
                        [
                          _c("div", { staticClass: "summary-label" }, [
                            _vm._v("Registros procesados"),
                          ]),
                          _c("div", { staticClass: "summary-value" }, [
                            _vm._v(_vm._s(_vm.rowCount.toLocaleString())),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm.columnCount
                    ? _c(
                        "div",
                        {
                          staticClass: "metric-item",
                          staticStyle: { flex: "1 1 0", "min-width": "0" },
                        },
                        [
                          _c("div", { staticClass: "summary-label" }, [
                            _vm._v("Columnas"),
                          ]),
                          _c("div", { staticClass: "summary-value" }, [
                            _vm._v(_vm._s(_vm.columnCount)),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm.profiling && _vm.profiling.scope
                    ? _c(
                        "div",
                        {
                          staticClass: "metric-item",
                          staticStyle: { flex: "1 1 0", "min-width": "0" },
                        },
                        [
                          _c("div", { staticClass: "summary-label" }, [
                            _vm._v("Alcance"),
                          ]),
                          _c("div", { staticClass: "summary-value" }, [
                            _vm._v(_vm._s(_vm.scopeLabel)),
                            _vm.profiling.scope === "INCREMENTAL" &&
                            _vm.profiling.scope_column
                              ? _c(
                                  "span",
                                  { staticClass: "summary-value-sub" },
                                  [
                                    _vm._v(
                                      " · " + _vm._s(_vm.profiling.scope_column)
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm.profiling && _vm.profiling.sampling_percent
                    ? _c(
                        "div",
                        {
                          staticClass: "metric-item",
                          staticStyle: { flex: "1 1 0", "min-width": "0" },
                        },
                        [
                          _c("div", { staticClass: "summary-label" }, [
                            _vm._v("Muestreo"),
                          ]),
                          _c("div", { staticClass: "summary-value" }, [
                            _vm._v(
                              _vm._s(_vm.profiling.sampling_percent) + "%"
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm.scheduleText
                    ? _c(
                        "div",
                        {
                          staticClass: "metric-item",
                          staticStyle: { flex: "1 1 0", "min-width": "0" },
                        },
                        [
                          _c("div", { staticClass: "summary-label" }, [
                            _vm._v("Programación"),
                          ]),
                          _c("div", { staticClass: "summary-value" }, [
                            _vm._v(_vm._s(_vm.scheduleText)),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ]
              ),
              _vm.hasFilters
                ? [
                    _c(VDivider, { staticClass: "my-2" }),
                    _c(
                      VRow,
                      { attrs: { dense: "" } },
                      [
                        _vm.profiling && _vm.profiling.row_filter
                          ? _c(VCol, { attrs: { cols: "12" } }, [
                              _c("div", { staticClass: "summary-label" }, [
                                _vm._v("Filtro de filas"),
                              ]),
                              _c("code", { staticClass: "summary-code" }, [
                                _vm._v(_vm._s(_vm.profiling.row_filter)),
                              ]),
                            ])
                          : _vm._e(),
                        _vm.profiling &&
                        _vm.profiling.include_fields &&
                        _vm.profiling.include_fields.length
                          ? _c(
                              VCol,
                              { attrs: { cols: "12", sm: "6" } },
                              [
                                _c(
                                  VExpansionPanels,
                                  { attrs: { flat: "" } },
                                  [
                                    _c(
                                      VExpansionPanel,
                                      [
                                        _c(
                                          VExpansionPanelHeader,
                                          {
                                            staticClass: "summary-panel-header",
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "summary-label" },
                                              [
                                                _vm._v(
                                                  "Columnas incluidas (" +
                                                    _vm._s(
                                                      _vm.profiling
                                                        .include_fields.length
                                                    ) +
                                                    ")"
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          VExpansionPanelContent,
                                          _vm._l(
                                            _vm.profiling.include_fields,
                                            function (f) {
                                              return _c(
                                                VChip,
                                                {
                                                  key: "in-" + f,
                                                  staticClass: "mr-1 mb-1",
                                                  attrs: {
                                                    "x-small": "",
                                                    label: "",
                                                    outlined: "",
                                                    color: "primary",
                                                  },
                                                },
                                                [_vm._v(_vm._s(f))]
                                              )
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.profiling &&
                        _vm.profiling.exclude_fields &&
                        _vm.profiling.exclude_fields.length
                          ? _c(
                              VCol,
                              { attrs: { cols: "12", sm: "6" } },
                              [
                                _c(
                                  VExpansionPanels,
                                  { attrs: { flat: "" } },
                                  [
                                    _c(
                                      VExpansionPanel,
                                      [
                                        _c(
                                          VExpansionPanelHeader,
                                          {
                                            staticClass: "summary-panel-header",
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "summary-label" },
                                              [
                                                _vm._v(
                                                  "Columnas excluidas (" +
                                                    _vm._s(
                                                      _vm.profiling
                                                        .exclude_fields.length
                                                    ) +
                                                    ")"
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          VExpansionPanelContent,
                                          _vm._l(
                                            _vm.profiling.exclude_fields,
                                            function (f) {
                                              return _c(
                                                VChip,
                                                {
                                                  key: "ex-" + f,
                                                  staticClass: "mr-1 mb-1",
                                                  attrs: {
                                                    "x-small": "",
                                                    label: "",
                                                    outlined: "",
                                                    color: "grey darken-1",
                                                  },
                                                },
                                                [_vm._v(_vm._s(f))]
                                              )
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
      _vm.items && _vm.items.length
        ? _c(VTextField, {
            staticClass: "mb-2 search-column",
            attrs: {
              "prepend-inner-icon": "mdi-magnify",
              placeholder: "Buscar columna...",
              dense: "",
              outlined: "",
              clearable: "",
              "hide-details": "",
            },
            model: {
              value: _vm.search,
              callback: function ($$v) {
                _vm.search = $$v
              },
              expression: "search",
            },
          })
        : _vm._e(),
      _c(VDataTable, {
        staticClass: "table-inca",
        attrs: {
          headers: _vm.headers_details,
          items: _vm.items,
          search: _vm.search,
          "hide-default-footer": true,
          page: _vm.pagination_details.current,
          "items-per-page": _vm.pagination_details.limit,
          "show-expand": "",
          expanded: _vm.expanded,
          "item-key": "name",
        },
        on: {
          "update:page": function ($event) {
            return _vm.$set(_vm.pagination_details, "current", $event)
          },
          pagination: function ($event) {
            _vm.pagination_details.total = $event.itemsLength
          },
          "update:expanded": function ($event) {
            _vm.expanded = $event
          },
        },
        scopedSlots: _vm._u([
          {
            key: "item.data-table-expand",
            fn: function (ref) {
              var item = ref.item
              var isExpanded = ref.isExpanded
              var expand = ref.expand
              return [
                _vm.hasExpandableData(item)
                  ? _c(
                      VBtn,
                      {
                        attrs: { icon: "", small: "" },
                        on: {
                          click: function ($event) {
                            return expand(!isExpanded)
                          },
                        },
                      },
                      [
                        _c(VIcon, { attrs: { small: "" } }, [
                          _vm._v(
                            _vm._s(
                              isExpanded ? "mdi-chevron-up" : "mdi-chevron-down"
                            )
                          ),
                        ]),
                      ],
                      1
                    )
                  : _c("span", {
                      staticStyle: { display: "inline-block", width: "28px" },
                    }),
              ]
            },
          },
          {
            key: "item.column",
            fn: function (ref) {
              var item = ref.item
              return [
                _c("span", { staticClass: "font-weight-medium" }, [
                  _vm._v(_vm._s(item.name)),
                ]),
              ]
            },
          },
          {
            key: "item.type",
            fn: function (ref) {
              var item = ref.item
              return [
                _c(
                  VChip,
                  {
                    attrs: {
                      "x-small": "",
                      label: "",
                      outlined: "",
                      color: "grey darken-1",
                    },
                  },
                  [_vm._v(_vm._s(item.type))]
                ),
              ]
            },
          },
          {
            key: "item.null_ratio",
            fn: function (ref) {
              var item = ref.item
              return [
                _c(
                  "div",
                  { staticClass: "ratio-cell" },
                  [
                    _c(VProgressLinear, {
                      staticClass: "ratio-bar",
                      attrs: {
                        value: _vm.nullPct(item),
                        color: _vm.nullColor(_vm.nullPct(item)),
                        "background-color": "grey lighten-3",
                        height: "6",
                        rounded: "",
                      },
                    }),
                    _c("span", { staticClass: "ratio-text" }, [
                      _vm._v(_vm._s(_vm.formatPct(_vm.nullPct(item)))),
                    ]),
                  ],
                  1
                ),
              ]
            },
          },
          {
            key: "item.distinct_ratio",
            fn: function (ref) {
              var item = ref.item
              return [
                _c(
                  "div",
                  { staticClass: "ratio-cell" },
                  [
                    _c(VProgressLinear, {
                      staticClass: "ratio-bar",
                      attrs: {
                        value: _vm.distinctPct(item),
                        color: "primary",
                        "background-color": "grey lighten-3",
                        height: "6",
                        rounded: "",
                      },
                    }),
                    _c("span", { staticClass: "ratio-text" }, [
                      _vm._v(_vm._s(_vm.formatPct(_vm.distinctPct(item)))),
                    ]),
                  ],
                  1
                ),
              ]
            },
          },
          {
            key: "expanded-item",
            fn: function (ref) {
              var headers = ref.headers
              var item = ref.item
              return [
                _c(
                  "td",
                  {
                    staticClass: "expanded-cell",
                    attrs: { colspan: headers.length },
                  },
                  [
                    _c(
                      VRow,
                      { attrs: { dense: "" } },
                      [
                        item.profile &&
                        (item.profile.stringProfile ||
                          item.profile.integerProfile ||
                          item.profile.doubleProfile)
                          ? _c(VCol, { attrs: { cols: "12", sm: "6" } }, [
                              _c("div", { staticClass: "detail-title" }, [
                                _vm._v("Estadísticas"),
                              ]),
                              item.profile.stringProfile
                                ? _c("div", [
                                    _c(
                                      "table",
                                      { staticClass: "stats-table" },
                                      [
                                        _c("tr", [
                                          _c("th", [
                                            _vm._v("Longitud promedio"),
                                          ]),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                item.profile.stringProfile
                                                  .averageLength
                                                  ? _vm.roundTwoDecimal(
                                                      item.profile.stringProfile
                                                        .averageLength
                                                    )
                                                  : "—"
                                              )
                                            ),
                                          ]),
                                        ]),
                                        _c("tr", [
                                          _c("th", [_vm._v("Longitud mínima")]),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                item.profile.stringProfile
                                                  .minLength
                                              )
                                            ),
                                          ]),
                                        ]),
                                        _c("tr", [
                                          _c("th", [_vm._v("Longitud máxima")]),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                item.profile.stringProfile
                                                  .maxLength
                                              )
                                            ),
                                          ]),
                                        ]),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                              item.profile.integerProfile
                                ? _c("div", [
                                    _c(
                                      "table",
                                      { staticClass: "stats-table" },
                                      [
                                        _c("tr", [
                                          _c("th", [_vm._v("Media")]),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.roundTwoDecimal(
                                                  item.profile.integerProfile
                                                    .average
                                                )
                                              )
                                            ),
                                          ]),
                                        ]),
                                        _c("tr", [
                                          _c("th", [_vm._v("Desv. estándar")]),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.roundTwoDecimal(
                                                  item.profile.integerProfile
                                                    .standardDeviation
                                                )
                                              )
                                            ),
                                          ]),
                                        ]),
                                        _c("tr", [
                                          _c("th", [_vm._v("Mínimo")]),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                item.profile.integerProfile.min
                                              )
                                            ),
                                          ]),
                                        ]),
                                        _c("tr", [
                                          _c("th", [_vm._v("Q1")]),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                item.profile.integerProfile
                                                  .quartiles[0]
                                              )
                                            ),
                                          ]),
                                        ]),
                                        _c("tr", [
                                          _c("th", [_vm._v("Mediana")]),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                item.profile.integerProfile
                                                  .quartiles[1]
                                              )
                                            ),
                                          ]),
                                        ]),
                                        _c("tr", [
                                          _c("th", [_vm._v("Q3")]),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                item.profile.integerProfile
                                                  .quartiles[2]
                                              )
                                            ),
                                          ]),
                                        ]),
                                        _c("tr", [
                                          _c("th", [_vm._v("Máximo")]),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                item.profile.integerProfile.max
                                              )
                                            ),
                                          ]),
                                        ]),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                              item.profile.doubleProfile
                                ? _c("div", [
                                    _c(
                                      "table",
                                      { staticClass: "stats-table" },
                                      [
                                        _c("tr", [
                                          _c("th", [_vm._v("Media")]),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.roundTwoDecimal(
                                                  item.profile.doubleProfile
                                                    .average
                                                )
                                              )
                                            ),
                                          ]),
                                        ]),
                                        _c("tr", [
                                          _c("th", [_vm._v("Desv. estándar")]),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.roundTwoDecimal(
                                                  item.profile.doubleProfile
                                                    .standardDeviation
                                                )
                                              )
                                            ),
                                          ]),
                                        ]),
                                        _c("tr", [
                                          _c("th", [_vm._v("Mínimo")]),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                item.profile.doubleProfile.min
                                              )
                                            ),
                                          ]),
                                        ]),
                                        _c("tr", [
                                          _c("th", [_vm._v("Q1")]),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                item.profile.doubleProfile
                                                  .quartiles[0]
                                              )
                                            ),
                                          ]),
                                        ]),
                                        _c("tr", [
                                          _c("th", [_vm._v("Mediana")]),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                item.profile.doubleProfile
                                                  .quartiles[1]
                                              )
                                            ),
                                          ]),
                                        ]),
                                        _c("tr", [
                                          _c("th", [_vm._v("Q3")]),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                item.profile.doubleProfile
                                                  .quartiles[2]
                                              )
                                            ),
                                          ]),
                                        ]),
                                        _c("tr", [
                                          _c("th", [_vm._v("Máximo")]),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                item.profile.doubleProfile.max
                                              )
                                            ),
                                          ]),
                                        ]),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                            ])
                          : _vm._e(),
                        item.profile &&
                        item.profile.topNValues &&
                        item.profile.topNValues.length
                          ? _c(VCol, { attrs: { cols: "12", sm: "6" } }, [
                              _c("div", { staticClass: "detail-title" }, [
                                _vm._v("Top valores"),
                              ]),
                              _c(
                                "table",
                                { staticClass: "topn-table" },
                                _vm._l(item.profile.topNValues, function (val) {
                                  return _c("tr", { key: val.value }, [
                                    _c(
                                      "th",
                                      [
                                        _c(
                                          VTooltip,
                                          {
                                            attrs: { top: "" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function (ref) {
                                                    var on = ref.on
                                                    var attrs = ref.attrs
                                                    return [
                                                      _c(
                                                        "span",
                                                        _vm._g(
                                                          _vm._b(
                                                            {},
                                                            "span",
                                                            attrs,
                                                            false
                                                          ),
                                                          on
                                                        ),
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.displayTopValue(
                                                                item,
                                                                val
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  item.type === "DATETIME" ||
                                                    item.type === "TIMESTAMP"
                                                    ? _vm.parseDate(val.value)
                                                    : val.value
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "td",
                                      [
                                        _c(VProgressLinear, {
                                          attrs: {
                                            rounded: "",
                                            color: "primary",
                                            "background-color":
                                              "grey lighten-3",
                                            value: _vm.roundTwoDecimal(
                                              val.ratio * 100
                                            ),
                                            height: "16",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function () {
                                                  return [
                                                    _c(
                                                      "strong",
                                                      {
                                                        staticClass: "topn-pct",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.roundTwoDecimal(
                                                              val.ratio * 100
                                                            )
                                                          ) + "%"
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ])
                                }),
                                0
                              ),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
      _c("pagination-vue", { attrs: { pagination: _vm.pagination_details } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }